import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  getDataCompany,
  getDataContactUs,
  getDataFooter,
} from "../helpers/fetchDataFooter";

const Footer = ({ moveTo }) => {
  const [footerData, setFooterData] = useState({
    logo_url: "",
    logo_title: "",
    address: "",
    dataCompany: [],
    email: "",
    phone_num: "",
  });

  const getLastData = (data) => {
    const lastData = data[data.length - 1];
    return lastData || null;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataFooter = await getLastData(await getDataFooter());
        const dataCompany = await getDataCompany();
        const dataContactUs = await getLastData(await getDataContactUs());

        setFooterData({
          logo_url: dataFooter.logo_url,
          logo_title: dataFooter.logo_title,
          address: dataFooter.address,
          dataCompany,
          email: dataContactUs.email,
          phone_num: dataContactUs.phone_num,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const { logo_url, logo_title, address, dataCompany, email, phone_num } =
    footerData;

  return (
    <footer ref={moveTo} className="text-body-tertiary m-0 py-3 px-0 w-100">
      <Container className="d-flex justify-content-between pb-4">
        <div className="col-6 row d-flex justify-content-start">
          <div
            style={{
              width: "40%",
              padding: "0",
            }}
          >
            <img src={logo_url} alt="icon" />
          </div>
          <p className="text-white p-0 text-opacity-50">{logo_title}</p>
          <p className="w-75 p-0 text-white">{address}</p>
        </div>
        <div className="col-6 d-flex column-gap-3 justify-content-end p-2">
          <div className="col-4 d-flex justify-content-end ps-5">
            <div className="w-auto">
              <h5 className="text-black fw-semibold mb-4">Company</h5>
              <div className="d-flex row row-gap-2">
                {dataCompany.map((item, index) => {
                  const { title, url } = item;
                  return (
                    <Link
                      key={index}
                      to={url}
                      className="text-white text-decoration-none text-opacity-75"
                    >
                      {title}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-4">
            <h5 className="text-black fw-semibold mb-4">Contact Us</h5>
            <div className="d-flex row row-gap-2">
              <Link
                to={"/"}
                className="text-white text-decoration-none w-auto text-opacity-75"
              >
                {email}
              </Link>
              <Link
                to={"/"}
                className="text-white text-decoration-none w-auto text-opacity-75"
              >
                {phone_num}
              </Link>
            </div>
          </div>
        </div>
      </Container>
      <Container className="border-top mx-auto py-3 px-0">
        <p className="m-0 text-white">2023 @ Ekata. All rights reserved.</p>
      </Container>
    </footer>
  );
};

export default Footer;
